import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "submitButton", "submitText", "spinner", "loadingText"]
  static values = { loadingLabel: String }

  connect() {
    // Ensure the form can't be submitted by pressing enter
    this.formTarget.addEventListener("keypress", (e) => {
      if (e.key === "Enter") {
        e.preventDefault()
      }
    })
  }

  // Called when the form starts submitting
  submitStart() {
    // Disable the submit button
    this.submitButtonTarget.disabled = true
    
    // Show loading state
    if (this.hasSubmitTextTarget) this.submitTextTarget.classList.add("opacity-0")
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")

    // Optional loading label shown next to spinner
    const label = this.hasLoadingLabelValue ? this.loadingLabelValue : null
    if (label && this.hasLoadingTextTarget) {
      this.loadingTextTarget.textContent = label
    }
  }

  // Called when the form submission is complete (success or error)
  submitEnd() {
    // Re-enable the submit button
    this.submitButtonTarget.disabled = false
    
    // Hide loading state
    if (this.hasSubmitTextTarget) this.submitTextTarget.classList.remove("opacity-0")
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
    if (this.hasLoadingTextTarget) this.loadingTextTarget.textContent = ""
  }
}
